import Missing, { IMissingProps } from "./missing";

const ListMissing = ({ type = "data", ...otherProps }: IListMissingProps) => {
  return <Missing title={`No ${type} yet`} {...otherProps} />;
};

interface IListMissingProps extends IMissingProps {}

export default ListMissing;
